export const IS_MOBILE = window.innerWidth < 767;
export const IS_TABLET = 767 < window.innerWidth < 1279;
const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(
        navigator.userAgent,
    );
};

export const IS_MOBILE_DEVICE = isMobileDevice();
